import React from 'react';
import EmailAiPopup from './EmailAiPopup';
import './BulkEmailPopup.css';

const BulkEmailPopup = ({
  isAiManagerOpen,
  isAutoSendOpen,
  bulkSelectedRows,
  bulkContactsData,
  localDbData,
  userId,
  onEmailResult,
  closeAiManager,
  closeAutoSend
}) => {
  if (!bulkSelectedRows.length || (!isAiManagerOpen && !isAutoSendOpen)) return null;

  // Verwende die vollständigen Kontaktdaten, falls vorhanden
  const allContacts = bulkContactsData && bulkContactsData.length > 0 
    ? bulkContactsData  // Bevorzuge die vollständigen, vorher gespeicherten Daten
    : bulkSelectedRows.map(id => localDbData.find(row => row.id === id)).filter(Boolean); // Fallback
  
  // Erste ausgewählte Zeile finden
  const firstSelectedRow = allContacts[0];
  
  if (!firstSelectedRow) return null;

  // Entscheiden, welcher Modus aktiv ist
  const isActive = isAiManagerOpen || isAutoSendOpen;
  const onClose = isAiManagerOpen ? closeAiManager : closeAutoSend;
  const autoSendMode = isAutoSendOpen;

  return (
    <div className="bulk-email-popup-container">
      <EmailAiPopup
        onClose={onClose}
        rowData={firstSelectedRow}
        userId={userId}
        onEmailResult={onEmailResult}
        source="worldDbTable"
        bulkMode={isAiManagerOpen}
        autoSendMode={autoSendMode}
        bulkContacts={bulkSelectedRows}
        allData={allContacts}
      />
    </div>
  );
};

export default BulkEmailPopup; 